import type { ReactNode } from "react";
import classNames from "classnames";
import styles from "./AppFrame.module.scss";

export const AppFrame = ({
  sidebar,
  header,
  children,
  variant = "fixed",
}: {
  sidebar: ReactNode;
  header: ReactNode;
  children: ReactNode;
  variant?: "fixed" | "embedded";
}) => {
  return (
    <div
      className={classNames(
        styles["comp"],
        variant === "embedded" && styles["comp--embedded"]
      )}
    >
      <div className={styles["comp__sidebar-nav"]}>{sidebar}</div>
      <div className={styles["comp__header"]}>{header}</div>
      <div className={styles["comp__view"]}>{children}</div>
    </div>
  );
};
